import React, { useEffect } from 'react';

import { IForm } from '@entities/AdminConversationCategory/model/types';
import { CustomModal, Image } from '@shared/ui';

import cls from './Survey.module.css';

interface SurveyProps {
    classes?: string;
    onClose?: () => void;
    prevData?: IForm;
}

export const Survey = ({ classes, onClose, prevData }: SurveyProps) => {
    // @ts-ignore
    const surveyData = modalData;

    useEffect(() => {
        const id = 'ya-forms-embed';
        if (!document.getElementById(id)) {
            const s = document.createElement('script');
            s.id = id;
            s.src = 'https://forms.yandex.ru/_static/embed.js';
            s.async = true;
            document.body.appendChild(s);
        }

        const handleMessage = (event: MessageEvent) => {
            if (event.origin !== 'https://forms.yandex.ru') return;

            try {
                const data = JSON.parse(event.data);
                if (data.message === 'sent') {
                    onClose?.();
                }
            } catch {
                // event.data не является JSON
            }
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [onClose]);

    return (
        <CustomModal.Body classes={cls.SurveyBody}>
            {(prevData?.image || surveyData?.image) && (
                <Image
                    wrapperClassName={cls.imageWrapper}
                    className={cls.image}
                    height={248}
                    width={440}
                    src={prevData ? prevData.image.originalUrl : surveyData.image.original_url}
                />
            )}

            <iframe
                src={prevData ? prevData.surveyUrl : surveyData.survey_url}
                className={cls.iframe}
            />
        </CustomModal.Body>
    );
};
